<div id="edit-user">
  <div mat-dialog-title>{{ 'UserEdit.EditUserInformation' | translate }}</div>
  <mat-form-field class="full-width" appearance="fill">
    <mat-label>{{ 'Global.search' | translate }}</mat-label>
    <input matInput [(ngModel)]="query" (keyup)="performSearch()" placeholder="Search users" autocomplete="off" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  @if (searchResult.length > 0) {
    <div class="result-box">
      @for (element of searchResult; track element) {
        <mat-card appearance="outlined" class="result-item">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image">
              <img [src]="element.photo" />
            </div>
            <mat-card-title>{{ element.fullName }}</mat-card-title>
            <mat-card-subtitle>{{ element.email }}</mat-card-subtitle>
          </mat-card-header>
          @if (currentUser._id != element._id) {
            <div class="expand-btn">
              <button mat-icon-button (click)="selectUser(element)">
                <mat-icon>expand_more</mat-icon>
              </button>
            </div>
          }
          @if (currentUser._id == element._id) {
            <div class="expand-btn">
              <button mat-icon-button (click)="selectUser(element)">
                <mat-icon>expand_less</mat-icon>
              </button>
            </div>
          }
          @if (currentUser._id == element._id) {
            <div>
              <div class="bottom-card-flex">
                <mat-form-field class="mb-1" appearance="fill">
                  <mat-label>{{ 'UserEdit.UserType' | translate }}</mat-label>
                  <mat-select name="type" [placeholder]="'UserEdit.UserType' | translate" [(ngModel)]="newUserRole" [disabled]="element.isOwner">
                    @for (type of userTypes; track type) {
                      <mat-option [value]="type">
                        {{ type }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <div class="full-width">
                  @if (!element.isOwner) {
                    <button class="mb-1 mr-1" mat-flat-button color="primary" (click)="setRole()" [disabled]="!(newUserRole && newUserRole.length > 0 && newUserRole != currentUser.role) || loading">
                      {{ 'UserEdit.Update' | translate }}
                    </button>
                  }
                  @if (!element.isOwner) {
                    <button class="mb-1" mat-flat-button color="warn" (click)="deleteUser(currentUser.id)" [disabled]="loading || currentUser._id == getCurrentUserID()">
                      {{ 'UserEdit.Delete' | translate }}
                    </button>
                  }
                </div>
              </div>
            </div>
          }
        </mat-card>
      }
    </div>
  }
</div>
